import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { Radar, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";
import { useScrollFadeIn, fadeCls, fadeStyle } from "@/hooks/useScrollFadeIn";

export default function RelarkThreeTierStack() {
  const { t } = useTranslation("ui");
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollFadeIn();

  return (
    <section className="py-16 sm:py-24">
      <div ref={ref} className="mx-auto max-w-3xl px-5">
        <div className={`text-center max-w-2xl mx-auto ${fadeCls(isVisible)}`}>
          <h2 className="text-2xl font-bold sm:text-3xl">
            {t("relark.tiers.title")}
          </h2>
          <p className="mt-3 text-muted-foreground">{t("relark.tiers.sub")}</p>
        </div>

        {/* Single hero tier card — Stress-Radar (Mest valgt). Reducerer valg-lammelse på landing. */}
        <div
          className={`mt-10 relative rounded-2xl border-2 border-primary bg-card p-6 sm:p-8 shadow-sm shadow-primary/10 ${fadeCls(isVisible)}`}
          style={fadeStyle(80)}
        >
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground">
            {t("relark.tiers.radar.popular")}
          </span>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <Radar className="h-5 w-5 text-primary" />
            </div>
            <h3 className="text-lg font-semibold">
              {t("relark.tiers.radar.name")}
            </h3>
          </div>
          <p className="text-3xl font-bold text-primary">
            {t("relark.tiers.radar.price")}
          </p>
          <p className="mt-1 text-sm font-medium text-foreground/80">
            {t("relark.tiers.radar.tagline")}
          </p>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            {t("relark.tiers.radar.desc")}
          </p>
          <Button
            className="mt-6 w-full rounded-full"
            onClick={() => {
              trackEvent("relark_tier_click", { tier: "radar" });
              navigate("/onboarding");
            }}
          >
            {t("relark.tiers.radar.cta")}
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>

        <div className={`mt-6 text-center ${fadeCls(isVisible)}`} style={fadeStyle(200)}>
          <Link
            to="/pricing"
            onClick={() => trackEvent("relark_pricing_link_click", { from: "three_tier_stack" })}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline underline-offset-4"
          >
            {t("relark.tiers.seeAllPlans")}
            <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
